import router from "./index"
import {SESSION_STORAGE_TOKEN} from "@/config/comm";
import {getStore} from "@/utils/storage";

//白名单
const whiteList = ["/", "/login", "/register"];

/**
 * 路由拦截
 */
router.beforeEach(async (to, from, next) => {
  await verification(to, from, next);
})

router.afterEach(() => {
  window.scrollTo(0, 0);
})


/**
 * 路由访问验证
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
export async function verification (to, from, next) {
  //白名单让通过
  // if (whiteList.includes(to.path)) {
    next();
  // } else if (await getStore(SESSION_STORAGE_TOKEN)) {
  //   next();
  // } else {
  //   next('/home');
  // }
}
